import { JobTabStateModel, WorkflowJobButtonModel, WorkflowStandardProcessingAction, WorkflowJobProcessResultModel } from '@/types';
import { ScriveSignersTabService } from '@/services/scrive/ScriveSignersTabService';
import { ScriveConstants } from '@/types';
import { EventBus } from '@/classes/EventBus';
import { mapActions, mapGetters } from 'vuex';

export const ScriveWorkflowJob = {
  methods: {
    ...mapActions('workflowJobStore', ['setActiveHorizontalTab']),
    async processWorkflowJob(this: any) {
      this.isLoading = true;
      if (this.processingAction !== WorkflowStandardProcessingAction.ProcessJob && this.processingAction !== WorkflowStandardProcessingAction.ExceptionJob) {
        await this.defaultProcessWorkflowJob();
        return;
      }

      try {
        if (this.processingAction === WorkflowStandardProcessingAction.ProcessJob) {
          await this.saveSignersDataAsync();
          await this.defaultProcessWorkflowJob();
        }
        if (this.processingAction === WorkflowStandardProcessingAction.ExceptionJob) {
          const processResult: WorkflowJobProcessResultModel = await this.sendDocumentForSigningAsync();
          if (processResult?.postProcessNavigation) {
            this.setPostProcessNavigation({ queueId: processResult.postProcessNavigation.queueId, jobId: processResult.postProcessNavigation?.jobId });
          }
          this.isLoading = false;
          this.setIsDirty(false);
          this.processGetNextJob();
        }
      } catch {
        this.isLoading = false;
        return;
      }
    },
    validateWorkflowJobAsync(this: any, processButton: WorkflowJobButtonModel) {
      this.defaultValidateWorkflowJobAsync(processButton);
      this.$nextTick(() => {
        EventBus.$emit(`dynamic-form-submit-m-dfCustom-ScriveSignersTab`);
      });
    },
    async saveSignersDataAsync(this: any) {
      const scriveSignersTabState = this.jobTabState(ScriveConstants.CustomSignersTabKey) as JobTabStateModel;
      if (scriveSignersTabState) {
        await ScriveSignersTabService.updateScriveSignersTabDataSourceAsync(this.workflowJob.jobId, this.signersTab.scriveSignersDataSource);
      }
    },
    async sendDocumentForSigningAsync(this: any): Promise<WorkflowJobProcessResultModel | undefined> {
      const scriveSignersTabState = this.jobTabState(ScriveConstants.CustomSignersTabKey) as JobTabStateModel;
      if (scriveSignersTabState) {
        const result = await ScriveSignersTabService.sendScriveDocumentForSigningAsync(this.workflowJob.jobId, this.signersTab.scriveSignersDataSource);
        return result;
      }
    }
  },
  computed: {
    ...mapGetters('scriveWorkflowJobStore', ['signersTab'])
  }
};
